import axios from '../utils/axios'

export function depositPaymentList(params) {
  return axios.post('/funds/apiFundsAh5Service/depositPaymentList', params)
}
export function rechargeDeposit(params) {
  return axios.post('/funds/apiFundsAh5Service/rechargeDeposit', params)
}
export function preFundInvestDetail(params) {
  return axios.post('/funds/apiFundsAh5Service/preFundInvestDetail', params)
}
export function preFundInvestList(params) {
  return axios.post('/funds/apiFundsAh5Service/preFundInvestList', params)
}
export function preFundInvestStatistics(params) {
  return axios.post('/funds/apiFundsAh5Service/preFundInvestStatistics', params)
}
export function getPreFundInvestDetailList(params) {
  return axios.post('/funds/apiFundsAh5Service/getPreFundInvestDetailList', params)
}
export function getPreFundInvestBalance(params) {
  return axios.post('/funds/apiFundsAh5Service/getPreFundInvestBalance', params)
}
export function rechargeByIntegral(params) {
  return axios.post('/funds/apiFundsAh5Service/rechargeByIntegral', params)
}
export function getDepositOrderListApi(params) {
  return axios.post('/funds/apiFundsAh5Service/getDepositOrderList', params)
}

export function getDepositOrderDetailApi(params) {
  return axios.post('/funds/apiFundsAh5Service/getDepositOrderDetail', params)
}

export function depositAuditApi(params) {
  return axios.post('/funds/apiFundsAh5Service/depositAudit', params)
}
// 预存款转赠
export function transferDeposit(params) {
  return axios.post('/funds/apiFundsAh5Service/transferDeposit', params)
}
